import * as React from "react";
import ListLoader from "../../../utils/loader/ListLoader";
import {IIsVisible} from "../../Checkout";
import KnownCustomer from "./KnownCustomer/KnownCustomer";
import NewCustomer from "./NewCustomer";

const Login: React.FC<IIsVisible> = (props) => {

  if (!props.isVisible) {
    return null;
  }

  return (
    <div className={"text"}>
      <React.Suspense fallback={<ListLoader />}>
        <KnownCustomer />
        <NewCustomer />
      </React.Suspense>
    </div>
  );
};

export default Login;
